<template>
  <div :class="showSwitcher ? 'pkd-root' : ''">
    <div v-if="showSwitcher" @click="switcher = !switcher" class="switcher" ref="switcher">
      <span v-show="switcher">
        <i class="fa fa-sort-alpha-desc"></i>
        {{areManyItems ? 'Nazwy' : 'Nazwa'}}
      </span>
      <span v-show="!switcher">
        <i class="fa fa-sort-numeric-asc"></i>
        {{areManyItems ? 'Symbole' : 'Symbol'}}
      </span>
    </div>
    <w-vue-select
      ref="select"
      :model="model"
      :values="showedOptions"
      :searchable="true"
      @input="fixLabels"
      :class="showSwitcher ? 'pkd-list' : ''"
      placeholder="Numery PKD..."
    >
      <span name="no-options">Przepraszamy, nie znaleziono podanego numeru PKD.</span>
    </w-vue-select>
    <small>{{this.count}} pierwszych pozycji</small>
  </div>
</template>

<script>
import axios from 'axios';

import WVueSelect from './vue-select.vue';
import modelMixin from '../mixins/modelMixin';

export default {
  name: 'pkd-select',
  components: {WVueSelect},
  mixins: [modelMixin],
  data() {
    return {
      options: [],
      showedOptions: [],
      switcher: true
    };
  },
  props: {
    url: {
      type: String,
      default: 'https://pkd.api.witkac.pl'
    },
    count: {
      type: Number,
      default: 100
    },
    showSwitcher: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    modelIsAnArray() {
      return this.model.$schema.type === 'array';
    },
    areManyItems() {
      return this.modelIsAnArray && this.model.$items.length > 1;
    }
  },
  methods: {
    getOptions() {
      axios
        .get(`${this.url}/?count=${this.count}`)
        .then(res => {
          this.options = res.data.list.map(item => ({value: item.symbol, text: item.nazwa}));
        })
        .catch(error => this.$emit('error', 'Nie udało się pobrać listy PKD'));
    },
    getShowedOptions() {
      if (this.switcher) this.showedOptions = this.options;
      else this.showedOptions = this.options.map(item => ({value: item.value, text: item.value}));
    },
    fixLabels(val) {
      if (!this.switcher)
        if (this.modelIsAnArray) {
          for (let i = 0; i < val.length; i++) {
            let item = this.options.find(x => x.value == val[i].value);
            this.model.$value[i].text = item.text;
          }
        } else if (this.model.$schema.type == 'object') {
          let text = this.options.find(x => x.value == val.value).text;
          this.$set(this.model.$value, 'text', text);
        }
    },
    setSwitcher() {
      this.$refs.select.$children[0].$el.append(this.$refs.switcher);
    }
  },
  watch: {
    options: {
      handler() {
        return this.getShowedOptions();
      },
      immediate: true
    },
    switcher: {
      handler() {
        return this.getShowedOptions();
      }
    }
  },
  beforeMount() {
    this.getOptions();
  },
  mounted() {
    this.setSwitcher();
  }
};
</script>
<style >
.pkd-root {
  position: relative;
}
.switcher {
  position: absolute !important;
  z-index: 1;
  left: 1px;
  top: 1px;
  cursor: pointer;
  color: #666;
  border-right: 1px solid #cdcdcd;
  width: 70px;
  padding: 5px 5px 4.5px 5px !important;
  background-color: #f5f5f5;
  border-radius: 4px 0px 0px 4px;
}
.switcher > i {
  height: 18px !important;
}
.pkd-list .vs__selected-options {
  margin-left: 80px;
}
</style>
